module.exports = __webpack_public_path__ + "assets/a-17-zhusheqi.666b432b.svg";